import {
  BookOutlined,
  ClockCircleOutlined,
  ReadOutlined,
  RightOutlined,
  SignalFilled,
  TrophyOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Tag, Progress, Button } from "antd";
import { useEffect, useState } from "react";
import { DASHBOARD_SUMMARY } from "../apis/apis";
import { useNavigate } from "react-router-dom";
import CulsightPageLoader from "../components/CulsightPageLoader";

function Dashboard() {
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [certificates, set_certificates] = useState(0);
  const [enrolled_courses, set_enrolled_courses] = useState(0);
  const [total_points, set_total_points] = useState(0);
  const [rank, set_rank] = useState(0);

  const [completedCourses, setCompletedCourses] = useState([]);
  const [continueLearning, setContinueLearning] = useState([]);

  const LIST_API = async () => {
    try {
      const FORM_DATA = new FormData();
      const API_CALL = await DASHBOARD_SUMMARY(FORM_DATA);

      if (API_CALL?.data?.status) {
        const data = API_CALL.data.data;

        set_certificates(data.certificates);
        set_enrolled_courses(data.enrolled_courses);
        set_total_points(data.total_points);
        set_rank(data.rank);

        setCompletedCourses(data.completed_course_names || []);
        setContinueLearning(data.continue_learning || []);
      }
    } catch (error) {
      console.error("Dashboard API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  if (loading) {
    return <div className="lms-body"><CulsightPageLoader /></div>;
  }

  return (
    <div className="lms-body">

      <Card>
        <h2>Dashboard</h2>


        {/* TOP STATS */}
        <Row gutter={[16, 16]}>
          {[
            {
              title: "Enrolled Courses",
              value: enrolled_courses,
              icon: <ReadOutlined />,
              color: "#8c3add",
              isOutline: true,
            },
            {
              title: "Certificates",
              value: certificates,
              icon: <BookOutlined />,
              color: "green",
            },
            {
              title: "Your Rank",
              value: rank,
              icon: <TrophyOutlined />,
              color: "orange",
            },
            {
              title: "Total Points",
              value: total_points,
              icon: <ClockCircleOutlined />,
              color: "cyan",
            },
          ].map((item, index) => (
            <Col key={index} xs={24} sm={12} md={12} lg={6}>
              <Card style={{ borderRadius: 16, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Tag
                    style={{
                      fontSize: 16,
                      height: 40,
                      width: 40,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: 16,
                      background: item.isOutline ? "#9b57df58" : undefined,
                      color: item.isOutline ? item.color : undefined,
                    }}
                    color={!item.isOutline ? item.color : undefined}
                  >
                    {item.icon}
                  </Tag>
                  <div>
                    <div style={{ fontSize: 14, color: "gray" }}>
                      {item.title}
                    </div>
                    <div style={{ fontSize: 22, fontWeight: "bold" }}>
                      {item.value || 0}
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>

        {/* CONTINUE LEARNING */}
        <Row justify="space-between" align="middle" style={{ marginTop: 20 }}>
          <Col>
            <h2>Continue Learning</h2>
          </Col>
          <Col>
            <span style={{ color: "#8c3add", cursor: "pointer" }} onClick={() => Navigate("/courses")}>
              View All
            </span>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {continueLearning.length > 0 ? (
            continueLearning.map((item, i) => (
              <Col key={i} xs={24} sm={12} lg={8}>
                <Card
                  hoverable
                  style={{ boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", borderRadius: 12 }}
                  cover={
                    <img
                      alt="course"
                      src={item.course_data.thumbnail}
                      style={{ height: 180, objectFit: "cover" }}
                    />
                  }
                > <h3
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                    {item.course_data.title}
                  </h3>

                  <p
                    style={{
                      color: "gray",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    Chapter : {item.chapter_data.title}
                  </p>

                  <Progress
                    percent={Math.round(item.course_data.progress)}
                    strokeColor="#8c3add"
                  />
                  <Button
                    block
                    style={{
                      marginTop: 10,
                      borderRadius: 8,
                      background: "linear-gradient(90deg, #7c3aed, #9333ea)",
                      border: "none",
                      color: "#fff",
                      fontWeight: 500,
                    }}
                    onClick={() =>
                      Navigate("/view-course/" + btoa(item.course_data.id))
                    }
                  >
                    {item.course_data.progress === 100 ? "Review" : `Continue (${item.course_data.progress}%)`}
                  </Button>
                </Card>
              </Col>
            ))
          ) : (
            <p>No courses in progress</p>
          )}
        </Row>

        {/* COMPLETED COURSES */}
        <Row justify="space-between" align="middle" style={{ marginTop: 20 }}>
          <Col>
            <h2>Completed Courses</h2>
          </Col>
          <Col>
            <span style={{ color: "#8c3add", cursor: "pointer" }} onClick={() => Navigate("/certificate")}>
              View Certificates
            </span>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          {completedCourses.length > 0 ? (
            completedCourses.map((course, i) => (
              <Col key={i} xs={24} sm={6} lg={6} style={{ display: "flex" }}>
                <Card
                  style={{
                    flex: 1,
                    height: 80, // fixed & reduced height
                    display: "flex",
                    alignItems: "center",
                  }}
                  bodyStyle={{ padding: 12 }}
                >
                  <div style={{ display: "flex", alignItems: "center", width: "100%" }}>

                    <Tag
                      color="green"
                      style={{
                        height: 36,
                        width: 36,
                        minWidth: 36,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: 12,
                      }}
                    >
                      <BookOutlined />
                    </Tag>

                    <div style={{ flex: 1, overflow: "hidden" }}>

                      {/* Course Name with Ellipsis */}
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        title={course}
                      >
                        {course}
                      </div>

                      <div style={{ fontSize: 12, color: "gray" }}>
                        Completed
                      </div>

                    </div>
                  </div>
                </Card>
              </Col>
            ))
          ) : (
            <p>No completed courses</p>
          )}
        </Row>

        {/* ACTION CARDS */}
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          {[
            {
              title: "Leaderboard",
              desc: "See where you rank among learners",
              route: "/leaderboard",
              icon: <SignalFilled style={{ fontSize: 24, color: "#fff" }} />,
            },
            {
              title: "Certificates",
              desc: "View and download certificates",
              route: "/certificate",
              icon: <BookOutlined style={{ fontSize: 24, color: "#fff" }} />,
            },
          ].map((item, i) => (
            <Col key={i} xs={24} md={12}>
              <Card hoverable style={{ borderRadius: 16 }} onClick={() => Navigate(item.route)}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                    <div
                      style={{
                        width: 56,
                        height: 56,
                        borderRadius: 12,
                        background:
                          "linear-gradient(135deg, #f7b500, #f29900)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {item.icon}
                    </div>

                    <div>
                      <div style={{ fontWeight: 600 }}>{item.title}</div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>
                        {item.desc}
                      </div>
                    </div>
                  </div>

                  <RightOutlined style={{ color: "#9ca3af" }} />
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>

    </div>
  );
}

export default Dashboard;